import { render, staticRenderFns } from "./ProfilesSection.vue?vue&type=template&id=13c610aa&"
import script from "./ProfilesSection.vue?vue&type=script&lang=js&"
export * from "./ProfilesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports